/**
 * record-footer.js
 */

import React from 'react';
import { Divider, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { format } from 'date-fns';


const useStyles = makeStyles(theme => ({
  footer: {
    // display: 'block',
    marginTop: theme.spacing(10),
    '& hr': {
      marginBottom: theme.spacing(1),
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '80%',
      },
    },
    '& .created-by': {
      fontSize: theme.typography.sizes[0],
      color: theme.palette.sys.onSurfaceVariant,
    }
  }
}));


export default function RecordFooter(props) {
  const {
    createdBy,
    dateCreated,
  } = props;

  const classes = useStyles();



  return (
    <div className={classes.footer}>
      <Divider />
      <Typography variant="caption" className="created-by">
        CREATED BY {createdBy}{dateCreated ? `, ${format(new Date(dateCreated), 'MM/dd/yyyy h:mm aaa')}` : ''}
      </Typography>
    </div>
  );
}